import styled from 'styled-components';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
import Avatar from '../Avatar';
import Paragraph from '../Paragraph';
import Caption from '../Caption';
import Button from '../Button';
import Link from '../Link';
var Comments = styled.div.withConfig({
  displayName: "Commentsstyles__Comments",
  componentId: "sc-1thzono-0"
})([""]);
var CommentsComment = styled.div.withConfig({
  displayName: "Commentsstyles__CommentsComment",
  componentId: "sc-1thzono-1"
})(["display:grid;grid-template-columns:40px 1fr;grid-template-rows:40px 1fr;gap:4px 8px;grid-template-areas:'avatar info' '. content';+ .", "-comments__comment{margin-top:16px;}+ .", "-comments__form{margin-top:16px;}+ .", "-comments__reply{margin-top:16px;margin-left:48px;}"], prefix, prefix, prefix);
var CommentsInfo = styled.div.attrs({
  className: "".concat(prefix, "-comments__info")
}).withConfig({
  displayName: "Commentsstyles__CommentsInfo",
  componentId: "sc-1thzono-2"
})(["grid-area:info;display:flex;flex-direction:column;justify-content:center;position:relative;"]);
var CommentsMetadata = styled.div.withConfig({
  displayName: "Commentsstyles__CommentsMetadata",
  componentId: "sc-1thzono-3"
})(["display:block;"]);
var CommentsMetadataText = styled(Paragraph).withConfig({
  displayName: "Commentsstyles__CommentsMetadataText",
  componentId: "sc-1thzono-4"
})(["display:inline;font-size:var(--dentsu-font-size-14) !important;line-height:", " !important;"], rem(20));
var CommentsMetadataDate = styled(Caption).attrs({
  isSecondary: true
}).withConfig({
  displayName: "Commentsstyles__CommentsMetadataDate",
  componentId: "sc-1thzono-5"
})([""]);
var CommentsCommentContent = styled.div.attrs({
  className: "".concat(prefix, "-comments__comment-content")
}).withConfig({
  displayName: "Commentsstyles__CommentsCommentContent",
  componentId: "sc-1thzono-6"
})(["grid-area:content;"]);
var CommentsCommentMessage = styled.div.attrs({
  className: "".concat(prefix, "-comments__comment-message")
}).withConfig({
  displayName: "Commentsstyles__CommentsCommentMessage",
  componentId: "sc-1thzono-7"
})(["padding-right:48px;font-size:var(--dentsu-font-size-14);line-height:", ";color:var(--dentsu-color-black);overflow-wrap:anywhere;& + *{margin-top:16px;}"], rem(20));
var CommentsForm = styled.div.withConfig({
  displayName: "Commentsstyles__CommentsForm",
  componentId: "sc-1thzono-8"
})(["> .", "-comments__comment-content{+ *{margin-top:8px;}}&.", "-comments__form--visible{+ .", "-comments__comment{margin-top:16px;}}&.", "-comments__form--new .", "-comments__form-content{padding-right:0;}"], prefix, prefix, prefix, prefix, prefix);
var CommentsFormContainer = styled.div.withConfig({
  displayName: "Commentsstyles__CommentsFormContainer",
  componentId: "sc-1thzono-9"
})(["display:grid;grid-template-columns:40px 1fr;grid-template-rows:1fr;gap:8px 8px;grid-template-areas:'avatar content';"]);
var CommentsFormContent = styled.div.attrs({
  className: "".concat(prefix, "-comments__form-content")
}).withConfig({
  displayName: "Commentsstyles__CommentsFormContent",
  componentId: "sc-1thzono-10"
})(["padding-right:48px;margin-bottom:16px;"]);
var CommentsFormActions = styled.div.attrs({
  className: "".concat(prefix, "-comments__form-actions")
}).withConfig({
  displayName: "Commentsstyles__CommentsFormActions",
  componentId: "sc-1thzono-11"
})(["display:inline-flex;flex-wrap:wrap;margin:-8px 0 0 -8px;width:calc(100% + 8px);> *{margin:8px 0 0 8px;}"]);
var CommentsActions = styled.div.withConfig({
  displayName: "Commentsstyles__CommentsActions",
  componentId: "sc-1thzono-12"
})(["position:absolute;right:0;top:0;"]);
var CommentsLoadPrevious = styled(Link).attrs({
  iconLeft: 'key-enter',
  iconProps: {
    style: {
      transform: 'scale(-1, 1)'
    }
  }
}).withConfig({
  displayName: "Commentsstyles__CommentsLoadPrevious",
  componentId: "sc-1thzono-13"
})(["margin-bottom:16px;"]);
var CommentsAvatar = styled(Avatar).attrs({
  size: 'xxlarge'
}).withConfig({
  displayName: "Commentsstyles__CommentsAvatar",
  componentId: "sc-1thzono-14"
})(["grid-area:avatar;"]);
var CommentsReply = styled(Button).attrs({
  size: 'small',
  variant: 'secondary'
}).withConfig({
  displayName: "Commentsstyles__CommentsReply",
  componentId: "sc-1thzono-15"
})([""]);
export var Styled = {
  Comments: Comments,
  CommentsAvatar: CommentsAvatar,
  CommentsInfo: CommentsInfo,
  CommentsActions: CommentsActions,
  CommentsMetadata: CommentsMetadata,
  CommentsMetadataText: CommentsMetadataText,
  CommentsMetadataDate: CommentsMetadataDate,
  CommentsComment: CommentsComment,
  CommentsLoadPrevious: CommentsLoadPrevious,
  CommentsReply: CommentsReply,
  CommentsCommentMessage: CommentsCommentMessage,
  CommentsCommentContent: CommentsCommentContent,
  CommentsForm: CommentsForm,
  CommentsFormContainer: CommentsFormContainer,
  CommentsFormContent: CommentsFormContent,
  CommentsFormActions: CommentsFormActions
};